// Korsa backend: AWS API Gateway (us-east-1, prod stage).
// Routes:
//   POST /waitlist { name, email }
//   POST /checkout {} -> { url } (Stripe Checkout session for the $500 pre-order)
//   POST /contact  { name, email, organizationType, subject, message }
//   POST /careers  { job, name, email, message }
const API_BASE = 'https://9mxupc0qmg.execute-api.us-east-1.amazonaws.com/prod';

export async function postJSON(path, payload) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`${path} failed: ${res.status}`);
  return res.json().catch(() => ({}));
}
